/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterLSmall = createReactComponent("outline", "letter-l-small", "IconLetterLSmall", [["path", { "d": "M10 8v8h4", "key": "svg-0" }]]);

export { IconLetterLSmall as default };
//# sourceMappingURL=IconLetterLSmall.mjs.map
